var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('v-img',{staticClass:"mx-auto mb-10",attrs:{"src":require('../assets/' + _vm.pageImage + '.png'),"width":"100%","max-width":"400px"}}),_c('p',{staticClass:"text-h5 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]),_c('p',{staticClass:"text-body-1",domProps:{"innerHTML":_vm._s(_vm.pageText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }